module.exports = __webpack_public_path__ + "static/sm_icon-f9abc10dfaa8e356b483.png";